import { FC } from 'react';
import { RouteRedirect } from 'modules/routing-module';

export const Monitors: FC = () => <RouteRedirect routeKey="MonitorsList" />;
